import { useApolloClient } from "@apollo/client";
import { useTranslate } from "@tolgee/react";
import { useSnackbar } from "notistack";
import { Button, ButtonProps } from "@mui/material";
import { useCancelOrganisationMembershipInvitationMutation } from "./CancelOrganisationMembershipInvitationButton.generated.js";

interface Props {
  invitationId: string;
  refetchQueries?: string[];
  size?: ButtonProps["size"];
  fullWidth?: ButtonProps["fullWidth"];
}

export const CancelOrganisationMembershipInvitationButton = ({
  invitationId,
  refetchQueries,
  size,
  fullWidth,
}: Props) => {
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslate(["OrganisationInvite"]);

  const client = useApolloClient();
  const [cancelInvitation] = useCancelOrganisationMembershipInvitationMutation({
    client,
  });

  async function cancel() {
    await cancelInvitation({
      variables: {
        organisationMembershipInvitationId: invitationId,
      },
      refetchQueries,
    });
    enqueueSnackbar(
      t("Invitation canceled", {
        ns: "OrganisationInvite",
      }),
      {
        variant: "info",
      }
    );
  }

  return (
    <Button
      size={size}
      fullWidth={fullWidth}
      variant="outlined"
      onClick={event => {
        event.stopPropagation();
        event.preventDefault();
        cancel();
      }}
    >
      {t("Cancel invitation", {
        ns: "OrganisationInvite",
      })}
    </Button>
  );
};
